import { AuthTokens } from '@/types/auth.types';

const TOKEN_KEY = 'auth_tokens';

export const tokenStorage = {
  setTokens(tokens: AuthTokens) {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
  },

  getTokens(): AuthTokens | null {
    const tokens = localStorage.getItem(TOKEN_KEY);
    return tokens ? JSON.parse(tokens) : null;
  },

  clearTokens() {
    localStorage.removeItem(TOKEN_KEY);
  },

  getAccessToken(): string | null {
    const tokens = this.getTokens();
    return tokens?.access || null;
  },

  getRefreshToken(): string | null {
    const tokens = this.getTokens();
    return tokens?.refresh || null;
  }
}; 